import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter , Navigate, Route, Routes } from 'react-router-dom';

import { AdminLayout } from './components/admin/AdminLayout';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import { ToastProvider } from './components/ui';
import { AuthProvider } from './context/AuthContext';
import { HeatherPanelProvider } from './context/HeatherPanelContext';
import { queryClient } from './lib/queryClient';
import { BillingPage } from './pages/admin/Billing';
import { DashboardPage } from './pages/admin/Dashboard';
import { EventDetailPage } from './pages/admin/EventDetail';
import { EventsPage } from './pages/admin/Events';
import { AdminForgotPage } from './pages/admin/Forgot';
import { AdminLoginPage } from './pages/admin/Login';
import { MemberDetailPage } from './pages/admin/MemberDetail';
import { MembersPage } from './pages/admin/Members';
import { NotificationsPage } from './pages/admin/Notifications';
import { PaymentsPage } from './pages/admin/Payments';
import { AdminResetPage } from './pages/admin/Reset';
import { SettingsPage } from './pages/admin/Settings';
import { AdminSignupPage } from './pages/admin/Signup';
import { UsersPage } from './pages/admin/Users';
import { AdminVerifyPage } from './pages/admin/Verify';
import { MemberPortal } from './pages/member/Portal';
import { ClubHome } from './pages/public/ClubHome';
import { EventDetail as PublicEventDetail } from './pages/public/EventDetail';
import { MarketingHome } from './pages/public/MarketingHome';
import { Register } from './pages/public/Register';
import { Registered } from './pages/public/Registered';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <HeatherPanelProvider>
            <ToastProvider>
            <Routes>
              <Route path="/" element={<MarketingHome />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/signup" element={<AdminSignupPage />} />
              <Route path="/admin/forgot" element={<AdminForgotPage />} />
              <Route path="/admin/reset" element={<AdminResetPage />} />
              <Route path="/admin/verify" element={<AdminVerifyPage />} />

              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="members" element={<MembersPage />} />
                <Route path="members/:id" element={<MemberDetailPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="events/:id" element={<EventDetailPage />} />
                <Route
                  path="payments"
                  element={
                    <ProtectedRoute roles={['OWNER', 'ADMIN', 'TREASURER']}>
                      <PaymentsPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route
                  path="users"
                  element={
                    <ProtectedRoute roles={['OWNER', 'ADMIN']}>
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="settings"
                  element={
                    <ProtectedRoute roles={['OWNER', 'ADMIN']}>
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="billing"
                  element={
                    <ProtectedRoute roles={['OWNER', 'ADMIN']}>
                      <BillingPage />
                    </ProtectedRoute>
                  }
                />
              </Route>

              <Route path="/m/:slug/*" element={<MemberPortal />} />
              <Route path="/:slug" element={<ClubHome />} />
              <Route path="/:slug/events/:eventId" element={<PublicEventDetail />} />
              <Route path="/:slug/events/:eventId/register" element={<Register />} />
              <Route path="/:slug/events/:eventId/registered" element={<Registered />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </ToastProvider>
          </HeatherPanelProvider>
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
